import { getDateString } from "../../utils/Utils";
import LocationCode from "../../utils/constants/LocationCode";

let UserSelectorDropdown = (props) => {

    let onClickUserItem = (user) => {
        if (user.userid !== -1) {
            props.onClickResult(user)
        }
    }

    return (
        <div className="user-selector-dropdown-wrapper">
            <div className="user-selector-dropdown-content">
                {props.userList.length !== 0 ?
                    props.userList.map((user) => {
                        return (
                            <div className="user-selector-result" key={user.name + "-" + user.userid}
                                onClick={(_) => onClickUserItem(user)}>
                                <p>{user.name + " (" + getDateString(new Date(user.birth)) + ") " +
                                    LocationCode.text[user.location]}</p>
                            </div>
                        )
                    }) :
                    <div className="user-selector-result">
                        <p>검색 결과 없음</p>
                    </div>
                }
            </div>
        </div>

    );
}
export default UserSelectorDropdown;